import { type User } from '@avanta/shared/types/users';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { QUERY_KEYS } from 'constants/common';
import { PatientService } from 'services/patients';
import { useUserStore } from 'stores/user';

interface UseFetchPatientOptions {
  refetchInterval?: number;
  maxAttempts?: number;
}

export const useFetchPatient = (
  options?: UseFetchPatientOptions
): { attempts: number | undefined } => {
  const { refetchInterval, maxAttempts = 5 } = options || {};
  const attemptsRef = useRef(0);
  const query = useQuery({
    queryKey: [QUERY_KEYS.FETCH_PATIENT],
    queryFn: () => {
      attemptsRef.current += 1;
      return PatientService.getPatient();
    },
    select: response => response.data,
    refetchInterval: refetchInterval
      ? (): number | false => (attemptsRef.current < maxAttempts ? refetchInterval : false)
      : undefined,
  });
  const { data, isSuccess } = query;
  const setUser = useUserStore(state => state.setUser);
  useEffect(() => {
    if (isSuccess && data) {
      setUser(data as User);
    }
  }, [isSuccess, data, setUser]);

  return { ...query, attempts: attemptsRef.current };
};
